export const getStatePortion = (state, levelOne, name) => {
  return state[levelOne][name];
};

export const getStateWithOnlyOneLevel = (state, levelOne) => {
  return state[levelOne];
};
